import { toString, FSharpRef, Record, Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { record_type, bool_type, string_type, lambda_type, unit_type, class_type, union_type, array_type, int32_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { UserState, UserState__ToInt, UserState_FromInt_Z524259A4, UserState__ToDescription, TrackLevelCourse_$reflection } from "../Shared/SharedModels.jsx";
import { NewGlobalRule, NewTrackLevelRule, NewTrackRule, UpdateGlobalRule, UpdateTrackLevelRule, UpdateTrackRule, ActionType__ToHint, ActionType__ToDescription, TriggerType__ToHint, TriggerType__ToDescription, TriggerType__IsTimeBased, RecipientType__ToDescription, TriggerConfig__GetDays, ChangeUserStateConfig, ActionConfig, NotificationConfig, TriggerConfig, RecipientType, RecipientType_$reflection, ActionType_$reflection, TriggerType_$reflection, ActionType, TriggerType, UpdateTrackLevelRule_$reflection, UpdateTrackRule_$reflection, UpdateGlobalRule_$reflection, TrackLevelRule_$reflection, TrackRule_$reflection, GlobalRule_$reflection, NewTrackLevelRule_$reflection, NewTrackRule_$reflection, NewGlobalRule_$reflection } from "../Shared/RuleModels.jsx";
import { ChevronRightRegular, ChevronLeftRegular, DismissRegular, ClockRegular, EditRegular, InfoRegular, TagRegular, AlertRegular, LockClosedRegular, LockOpenRegular, PauseRegular, PersonRegular, MailRegular, FlashRegular, ArrowUpRegular, PersonAddRegular, CheckmarkRegular, CalendarRegular, TimerRegular } from "@fluentui/react-icons";
import { createElement } from "react";
import React from "react";
import { FSharpSet__Contains, unionMany, ofList } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { tail, head, isEmpty, empty, singleton, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { int32ToString, createObj, equals, comparePrimitives } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { replace, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { ofNullable, orElseWith, toArray, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { tryFind, ofList as ofList_1 } from "../fable_modules/fable-library-js.4.29.0/Map.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { Caption1, Body1Strong, CardHeader, Card, DialogSurface, DialogTrigger, Dialog, Checkbox, Textarea, Input, Switch, Text as Text$, Option, Dropdown, SpinButton, Field, Button, Tooltip, tokens as tokens_1 } from "@fluentui/react-components";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { take as take_1, length, collect, toArray as toArray_1, iterate, tryHead, empty as empty_1, append, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { take, item, choose, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { tryParse } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";

export class DialogScope extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GlobalScope", "TrackScope", "TrackLevelScope"];
    }
}

export function DialogScope_$reflection() {
    return union_type("Rules.RuleDialog.DialogScope", [], DialogScope, () => [[], [["trackId", int32_type]], [["trackLevelId", int32_type], ["courses", array_type(TrackLevelCourse_$reflection())]]]);
}

export class NewRule extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GlobalRule", "TrackRule", "TrackLevelRule"];
    }
}

export function NewRule_$reflection() {
    return union_type("Rules.RuleDialog.NewRule", [], NewRule, () => [[["Item", NewGlobalRule_$reflection()]], [["Item", NewTrackRule_$reflection()]], [["Item", NewTrackLevelRule_$reflection()]]]);
}

export class ExistingRule extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExistingGlobalRule", "ExistingTrackRule", "ExistingTrackLevelRule"];
    }
}

export function ExistingRule_$reflection() {
    return union_type("Rules.RuleDialog.ExistingRule", [], ExistingRule, () => [[["Item", GlobalRule_$reflection()]], [["Item", TrackRule_$reflection()]], [["Item1", TrackLevelRule_$reflection()], ["courses", array_type(TrackLevelCourse_$reflection())]]]);
}

export class RuleUpdate extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GlobalRule", "TrackRule", "TrackLevelRule"];
    }
}

export function RuleUpdate_$reflection() {
    return union_type("Rules.RuleDialog.RuleUpdate", [], RuleUpdate, () => [[["Item", UpdateGlobalRule_$reflection()]], [["Item", UpdateTrackRule_$reflection()]], [["Item", UpdateTrackLevelRule_$reflection()]]]);
}

export class DialogMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddMode", "EditMode"];
    }
}

export function DialogMode_$reflection() {
    return union_type("Rules.RuleDialog.DialogMode", [], DialogMode, () => [[["scope", DialogScope_$reflection()], ["trigger", class_type("Fable.React.ReactElement")], ["onSave", lambda_type(NewRule_$reflection(), unit_type)]], [["existingRule", ExistingRule_$reflection()], ["onSave", lambda_type(RuleUpdate_$reflection(), unit_type)], ["onClose", lambda_type(unit_type, unit_type)]]]);
}

function triggersForScope(scope) {
    switch (scope.tag) {
        case 1:
            return [new TriggerType(5, []), new TriggerType(6, []), new TriggerType(7, [])];
        case 2:
            return [new TriggerType(8, []), new TriggerType(9, []), new TriggerType(10, []), new TriggerType(11, [])];
        default:
            return [new TriggerType(2, []), new TriggerType(3, []), new TriggerType(4, [])];
    }
}

function actionsForScope(scope) {
    switch (scope.tag) {
        case 1:
            return [new ActionType(0, []), new ActionType(1, []), new ActionType(3, []), new ActionType(4, []), new ActionType(5, [])];
        case 2:
            return [new ActionType(0, []), new ActionType(1, []), new ActionType(3, []), new ActionType(4, []), new ActionType(5, [])];
        default:
            return [new ActionType(0, []), new ActionType(1, []), new ActionType(2, []), new ActionType(4, []), new ActionType(5, [])];
    }
}

function defaultTriggerForScope(scope) {
    switch (scope.tag) {
        case 1:
            return new TriggerType(5, []);
        case 2:
            return new TriggerType(8, []);
        default:
            return new TriggerType(2, []);
    }
}

function triggerIconForType(triggerType) {
    switch (triggerType.tag) {
        case 2:
        case 5:
        case 8: {
            const el = TimerRegular;
            return createElement(el, {
                fontSize: 20,
            });
        }
        case 3:
        case 6:
        case 9: {
            const el_2 = CalendarRegular;
            return createElement(el_2, {
                fontSize: 20,
            });
        }
        case 4: {
            const el_4 = CheckmarkRegular;
            return createElement(el_4, {
                fontSize: 20,
            });
        }
        case 7: {
            const el_6 = PersonAddRegular;
            return createElement(el_6, {
                fontSize: 20,
            });
        }
        case 10: {
            const el_8 = ArrowUpRegular;
            return createElement(el_8, {
                fontSize: 20,
            });
        }
        case 11: {
            const el_10 = CheckmarkRegular;
            return createElement(el_10, {
                fontSize: 20,
            });
        }
        default: {
            const el_12 = FlashRegular;
            return createElement(el_12, {
                fontSize: 20,
            });
        }
    }
}

function actionIconForType(actionType) {
    switch (actionType.tag) {
        case 1: {
            const el_2 = MailRegular;
            return createElement(el_2, {
                fontSize: 20,
            });
        }
        case 2: {
            const el_4 = PersonRegular;
            return createElement(el_4, {
                fontSize: 20,
            });
        }
        case 3: {
            const el_6 = PauseRegular;
            return createElement(el_6, {
                fontSize: 20,
            });
        }
        case 4: {
            const el_8 = LockOpenRegular;
            return createElement(el_8, {
                fontSize: 20,
            });
        }
        case 5: {
            const el_10 = LockClosedRegular;
            return createElement(el_10, {
                fontSize: 20,
            });
        }
        default: {
            const el = AlertRegular;
            return createElement(el, {
                fontSize: 20,
            });
        }
    }
}

function scopeLabel(scope) {
    switch (scope.tag) {
        case 1:
            return "læringsløp-automatisering";
        case 2:
            return "nivå-automatisering";
        default:
            return "global automatisering";
    }
}

function tokenKeysForTrigger(triggerType) {
    const userKeys = ofList(ofArray(["USER_NAME", "FIRST_NAME", "LAST_NAME"]), {
        Compare: comparePrimitives,
    });
    const extras = (triggerType.tag === 2) ? singleton("DAYS_INACTIVE") : ((triggerType.tag === 3) ? empty() : ((triggerType.tag === 4) ? empty() : ((triggerType.tag === 5) ? ofArray(["DAYS_INACTIVE", "TRACK_NAME"]) : ((triggerType.tag === 6) ? singleton("TRACK_NAME") : ((triggerType.tag === 7) ? singleton("TRACK_NAME") : ((triggerType.tag === 8) ? ofArray(["DAYS_INACTIVE", "TRACK_NAME", "LEVEL_NAME"]) : ((triggerType.tag === 9) ? ofArray(["DAYS_ON_LEVEL", "TRACK_NAME", "LEVEL_NAME"]) : ((triggerType.tag === 10) ? ofArray(["TRACK_NAME", "LEVEL_NAME"]) : ((triggerType.tag === 11) ? ofArray(["TRACK_NAME", "LEVEL_NAME"]) : empty())))))))));
    return unionMany([userKeys, ofList(singleton("URL"), {
        Compare: comparePrimitives,
    }), ofList(extras, {
        Compare: comparePrimitives,
    })], {
        Compare: comparePrimitives,
    });
}

class Step extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BasicInfo", "Trigger", "Action"];
    }
}

function Step_$reflection() {
    return union_type("Rules.RuleDialog.Step", [], Step, () => [[], [], []]);
}

class CourseFilterMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AllCourses", "SelectedCourses"];
    }
}

function CourseFilterMode_$reflection() {
    return union_type("Rules.RuleDialog.CourseFilterMode", [], CourseFilterMode, () => [[], []]);
}

class Model extends Record {
    constructor(Step, Name, Description, Enabled, ShowAutomationCountdown, TriggerType, Days, CourseFilterMode, CourseFilterIds, RequireAllCourses, ActionType, Title, Message, Url, Recipient, AlsoEmail, UseCustomMessage, NewState, DemoteBy, IsSaving) {
        super();
        this.Step = Step;
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.Days = (Days | 0);
        this.CourseFilterMode = CourseFilterMode;
        this.CourseFilterIds = CourseFilterIds;
        this.RequireAllCourses = RequireAllCourses;
        this.ActionType = ActionType;
        this.Title = Title;
        this.Message = Message;
        this.Url = Url;
        this.Recipient = Recipient;
        this.AlsoEmail = AlsoEmail;
        this.UseCustomMessage = UseCustomMessage;
        this.NewState = (NewState | 0);
        this.DemoteBy = (DemoteBy | 0);
        this.IsSaving = IsSaving;
    }
}

function Model_$reflection() {
    return record_type("Rules.RuleDialog.Model", [], Model, () => [["Step", Step_$reflection()], ["Name", string_type], ["Description", string_type], ["Enabled", bool_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["Days", int32_type], ["CourseFilterMode", CourseFilterMode_$reflection()], ["CourseFilterIds", array_type(int32_type)], ["RequireAllCourses", bool_type], ["ActionType", ActionType_$reflection()], ["Title", string_type], ["Message", string_type], ["Url", string_type], ["Recipient", RecipientType_$reflection()], ["AlsoEmail", bool_type], ["UseCustomMessage", bool_type], ["NewState", int32_type], ["DemoteBy", int32_type], ["IsSaving", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStep", "NextStep", "PrevStep", "SetName", "SetDescription", "SetEnabled", "SetShowAutomationCountdown", "SetTriggerType", "SetDays", "SetCourseFilterMode", "SetCourseFilterIds", "SetRequireAllCourses", "SetActionType", "SetTitle", "SetMessage", "SetUrl", "SetRecipient", "SetAlsoEmail", "SetUseCustomMessage", "SetNewState", "SetDemoteBy", "SetIsSaving", "ResetForm", "ResetFormWithRule"];
    }
}

function Msg_$reflection() {
    return union_type("Rules.RuleDialog.Msg", [], Msg, () => [[["Item", Step_$reflection()]], [], [], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", TriggerType_$reflection()]], [["Item", int32_type]], [["Item", CourseFilterMode_$reflection()]], [["Item", array_type(int32_type)]], [["Item", bool_type]], [["Item", ActionType_$reflection()]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", RecipientType_$reflection()]], [["Item", bool_type]], [["Item", bool_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", bool_type]], [["Item", DialogScope_$reflection()]], [["Item", ExistingRule_$reflection()]]]);
}

function init(scope) {
    return new Model(new Step(0, []), "", "", true, false, defaultTriggerForScope(scope), 30, new CourseFilterMode(0, []), new Int32Array([]), false, new ActionType(0, []), "", "", "", new RecipientType(0, []), false, false, 2, 1, false);
}

function createTriggerConfig(triggerType, days) {
    switch (triggerType.tag) {
        case 2:
        case 5:
        case 8:
        case 9:
            return new TriggerConfig(0, [days]);
        case 3:
        case 6:
            return new TriggerConfig(1, [days]);
        case 11:
            return new TriggerConfig(2, [days]);
        default:
            return new TriggerConfig(3, []);
    }
}

function createActionConfig(actionType, title, message, url, recipient, alsoEmail, useCustomMessage, newState, demoteBy) {
    let trimmedUrl_1;
    const buildNotification = () => {
        const trimmedUrl = url.trim();
        return new ActionConfig(0, [new NotificationConfig(title, message, recipient, alsoEmail, isNullOrWhiteSpace(trimmedUrl) ? undefined : trimmedUrl)]);
    };
    let matchResult;
    switch (actionType.tag) {
        case 0:
        case 1: {
            matchResult = 0;
            break;
        }
        case 4: {
            if (useCustomMessage) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 5: {
            if (useCustomMessage) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 3: {
            if (useCustomMessage) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        default:
            matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return buildNotification();
        case 1:
            return buildNotification();
        default:
            if (actionType.tag === 2) {
                return new ActionConfig(1, [new ChangeUserStateConfig(newState, useCustomMessage ? ((trimmedUrl_1 = url.trim(), new NotificationConfig(title, message, recipient, alsoEmail, isNullOrWhiteSpace(trimmedUrl_1) ? undefined : trimmedUrl_1))) : undefined)]);
            }
            else {
                return new ActionConfig(2, []);
            }
    }
}

function extractTriggerDays(config) {
    return TriggerConfig__GetDays(config);
}

function extractActionFields(config) {
    switch (config.tag) {
        case 1: {
            const payload = config.fields[0];
            const matchValue = payload.Notification;
            if (matchValue == null) {
                return ["", "", "", new RecipientType(0, []), false, false, payload.NewState, 1];
            }
            else {
                const c_1 = matchValue;
                return [c_1.Title, c_1.Message, defaultArg(c_1.Url, ""), c_1.Recipients, c_1.SendEmail, true, payload.NewState, 1];
            }
        }
        case 2:
            return ["", "", "", new RecipientType(0, []), false, false, 2, 1];
        default: {
            const c = config.fields[0];
            return [c.Title, c.Message, defaultArg(c.Url, ""), c.Recipients, c.SendEmail, true, 2, 1];
        }
    }
}

function scopeFromExistingRule(rule) {
    switch (rule.tag) {
        case 1:
            return new DialogScope(1, [rule.fields[0].TrackId]);
        case 2:
            return new DialogScope(2, [rule.fields[0].TrackLevelId, rule.fields[1]]);
        default:
            return new DialogScope(0, []);
    }
}

function initFromExistingRule(rule) {
    let patternInput;
    switch (rule.tag) {
        case 1: {
            const r_1 = rule.fields[0];
            patternInput = [r_1.Name, defaultArg(r_1.Description, ""), r_1.Enabled, r_1.ShowAutomationCountdown, r_1.TriggerType, r_1.TriggerConfig, r_1.ActionType, r_1.ActionConfig, new Int32Array([]), false];
            break;
        }
        case 2: {
            const r_2 = rule.fields[0];
            patternInput = [r_2.Name, defaultArg(r_2.Description, ""), r_2.Enabled, r_2.ShowAutomationCountdown, r_2.TriggerType, r_2.TriggerConfig, r_2.ActionType, r_2.ActionConfig, r_2.CourseFilterIds, r_2.RequireAllCourses];
            break;
        }
        default: {
            const r = rule.fields[0];
            patternInput = [r.Name, defaultArg(r.Description, ""), r.Enabled, r.ShowAutomationCountdown, r.TriggerType, r.TriggerConfig, r.ActionType, r.ActionConfig, new Int32Array([]), false];
        }
    }
    const courseFilterIds = patternInput[8];
    const days = extractTriggerDays(patternInput[5]) | 0;
    const patternInput_1 = extractActionFields(patternInput[7]);
    return new Model(new Step(0, []), patternInput[0], patternInput[1], patternInput[2], patternInput[3], patternInput[4], days, (courseFilterIds.length > 0) ? (new CourseFilterMode(1, [])) : (new CourseFilterMode(0, [])), courseFilterIds, patternInput[9], patternInput[6], patternInput_1[0], patternInput_1[1], patternInput_1[2], patternInput_1[3], patternInput_1[4], patternInput_1[5], patternInput_1[6], patternInput_1[7], false);
}

function nextStep(step) {
    switch (step.tag) {
        case 1:
            return new Step(2, []);
        case 2:
            return new Step(2, []);
        default:
            return new Step(1, []);
    }
}

function prevStep(step) {
    switch (step.tag) {
        case 1:
            return new Step(0, []);
        case 2:
            return new Step(1, []);
        default:
            return new Step(0, []);
    }
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(nextStep(model.Step), model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 2:
            return new Model(prevStep(model.Step), model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 3:
            return new Model(model.Step, msg.fields[0], model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 4:
            return new Model(model.Step, model.Name, msg.fields[0], model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 5:
            return new Model(model.Step, model.Name, model.Description, msg.fields[0], model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 6:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, msg.fields[0], model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 7: {
            const v_5 = msg.fields[0];
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, v_5, model.Days, equals(v_5, new TriggerType(11, [])) ? (new CourseFilterMode(1, [])) : model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        }
        case 8:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, msg.fields[0], model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 9:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, msg.fields[0], model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 10:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, msg.fields[0], model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 11:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, msg.fields[0], model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 12:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, msg.fields[0], model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 13:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, msg.fields[0], model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 14:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, msg.fields[0], model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 15:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, msg.fields[0], model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 16:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, msg.fields[0], model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 17:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, msg.fields[0], model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
        case 18:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, msg.fields[0], model.NewState, model.DemoteBy, model.IsSaving);
        case 19:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, msg.fields[0], model.DemoteBy, model.IsSaving);
        case 20:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, msg.fields[0], model.IsSaving);
        case 21:
            return new Model(model.Step, model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, msg.fields[0]);
        case 22:
            return init(msg.fields[0]);
        case 23:
            return initFromExistingRule(msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Name, model.Description, model.Enabled, model.ShowAutomationCountdown, model.TriggerType, model.Days, model.CourseFilterMode, model.CourseFilterIds, model.RequireAllCourses, model.ActionType, model.Title, model.Message, model.Url, model.Recipient, model.AlsoEmail, model.UseCustomMessage, model.NewState, model.DemoteBy, model.IsSaving);
    }
}

export class Token extends Record {
    constructor(Key, Description) {
        super();
        this.Key = Key;
        this.Description = Description;
    }
}

export function Token_$reflection() {
    return record_type("Rules.RuleDialog.Token", [], Token, () => [["Key", string_type], ["Description", string_type]]);
}

export const tokens = [new Token("USER_NAME", "Fullt navn"), new Token("FIRST_NAME", "Fornavn"), new Token("LAST_NAME", "Etternavn"), new Token("TRACK_NAME", "Læringsløp"), new Token("LEVEL_NAME", "Nivå"), new Token("DAYS_INACTIVE", "Antall dager inaktiv"), new Token("DAYS_ON_LEVEL", "Dager på nivå"), new Token("URL", "Lenke")];

export const sampleData = ofList_1(ofArray([["USER_NAME", "Anja Berg"], ["FIRST_NAME", "Anja"], ["LAST_NAME", "Berg"], ["TRACK_NAME", "Grunnleggende brannvern"], ["LEVEL_NAME", "Modul 3: Evakuering"], ["DAYS_INACTIVE", "42"], ["DAYS_ON_LEVEL", "17"], ["URL", "/laeringslop/1"]]), {
    Compare: comparePrimitives,
});

function replaceTokens(text_mut, remaining_mut) {
    replaceTokens:
    while (true) {
        const text = text_mut, remaining = remaining_mut;
        if (!isEmpty(remaining)) {
            const token = head(remaining);
            const placeholder = `{${token.Key}}`;
            text_mut = replace(text, placeholder, defaultArg(tryFind(token.Key, sampleData), placeholder));
            remaining_mut = tail(remaining);
            continue replaceTokens;
        }
        else {
            return text;
        }
        break;
    }
}

export function renderTokens(text) {
    return replaceTokens(text, ofArray(tokens));
}

export function TokenStrip(tokenStripInputProps) {
    let elems_3, elems_1, elems, el, elems_2;
    const onInsert = tokenStripInputProps.onInsert;
    const triggerType = tokenStripInputProps.triggerType;
    const allowed = tokenKeysForTrigger(triggerType);
    const visible = tokens.filter((t) => FSharpSet__Contains(allowed, t.Key));
    if (visible.length === 0) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(ofArray([["style", {
            backgroundColor: tokens_1.colorNeutralBackground2,
            border: (((1 + "px ") + "dashed") + " ") + tokens_1.colorNeutralStroke2,
            borderRadius: 4,
            padding: 10,
            marginTop: 6,
        }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 6 + "px ",
            marginBottom: 6,
        }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
            color: tokens_1.colorNeutralForeground3,
            fontSize: 12 + "px",
        }], (elems = [(el = TagRegular, createElement(el, {}))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", {
            style: {
                fontSize: 11 + "px",
                fontWeight: 600,
                color: tokens_1.colorNeutralForeground2,
                letterSpacing: "0.3px",
                textTransform: "uppercase",
            },
            children: "Tilgjengelige plassholdere",
        }), createElement("div", {
            style: {
                fontSize: 11 + "px",
                color: tokens_1.colorNeutralForeground3,
                marginLeft: "auto",
            },
            children: "Klikk for å sette inn",
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            gap: 4 + "px ",
        }], (elems_2 = toList(delay(() => map((token) => {
            let el_2;
            const el_4 = Tooltip;
            return createElement(el_4, {
                content: `Setter inn {${token.Key}}`,
                relationship: "description",
                children: (el_2 = Button, createElement(el_2, {
                    onClick: (_arg) => {
                        onInsert(`{${token.Key}}`);
                    },
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        backgroundColor: tokens_1.colorNeutralBackground3,
                        color: tokens_1.colorNeutralForeground2,
                        border: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke2,
                        borderRadius: 2,
                        fontSize: 12 + "px",
                        padding: ((2 + "px ") + 6) + "px",
                        cursor: "pointer",
                    },
                    children: token.Description,
                })),
            });
        }, visible))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
}

function NotificationPreview(model) {
    let elems_1, children, el, elems, elems_9, elems_3, elems_2, elems_8, elems_7;
    const isEmail = equals(model.ActionType, new ActionType(1, []));
    if (!equals(model.ActionType, new ActionType(0, [])) && !isEmail) {
        let actionLabel;
        const matchValue = model.ActionType;
        actionLabel = ((matchValue.tag === 2) ? "Endre brukerstatus" : ((matchValue.tag === 3) ? "Sett læringsløp inaktivt" : ((matchValue.tag === 4) ? "Gi tilgang til materiale" : ((matchValue.tag === 5) ? "Fjern tilgang til materiale" : "Handling"))));
        let actionDesc;
        const matchValue_1 = model.ActionType;
        actionDesc = ((matchValue_1.tag === 2) ? "Endrer brukerens status i systemet" : ((matchValue_1.tag === 3) ? "Merker brukerens læringsløp som inaktivt" : ((matchValue_1.tag === 4) ? "Gir brukeren tilgang til materialer" : ((matchValue_1.tag === 5) ? "Fjerner brukerens tilgang til materialer" : ""))));
        return createElement("div", createObj(ofArray([["style", {
            border: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke2,
            borderRadius: 4,
            backgroundColor: tokens_1.colorNeutralBackground1,
            padding: 14,
            display: "flex",
            gap: 10 + "px ",
            alignItems: "flex-start",
        }], (elems_1 = [(children = singleton((el = FlashRegular, createElement(el, {
            primaryFill: tokens_1.colorBrandForeground1,
        }))), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), createElement("div", createObj(singleton((elems = [createElement("div", {
            style: {
                fontSize: 13 + "px",
                fontWeight: 600,
                color: tokens_1.colorNeutralForeground1,
            },
            children: actionLabel,
        }), createElement("div", {
            style: {
                fontSize: 12 + "px",
                color: tokens_1.colorNeutralForeground2,
                marginTop: 2,
            },
            children: actionDesc,
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
    else {
        const title = isNullOrWhiteSpace(model.Title) ? (isEmail ? "Emne ..." : "Tittel ...") : renderTokens(model.Title);
        const message = isNullOrWhiteSpace(model.Message) ? "Meldingen vises her når du skriver." : renderTokens(model.Message);
        const recipientLabel = RecipientType__ToDescription(model.Recipient);
        return createElement("div", createObj(ofArray([["style", {
            border: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke2,
            borderRadius: 4,
            backgroundColor: tokens_1.colorNeutralBackground1,
            overflow: "hidden",
        }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
            padding: ((8 + "px ") + 12) + "px",
            backgroundColor: tokens_1.colorNeutralBackground2,
            borderBottom: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke3,
            display: "flex",
            gap: 8 + "px ",
            alignItems: "center",
        }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
            color: tokens_1.colorNeutralForeground2,
            fontSize: 14 + "px",
            display: "flex",
            alignItems: "center",
        }], (elems_2 = toList(delay(() => {
            let el_2, el_4;
            return isEmail ? singleton_1((el_2 = MailRegular, createElement(el_2, {}))) : singleton_1((el_4 = AlertRegular, createElement(el_4, {})));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("span", {
            style: {
                fontSize: 11 + "px",
                color: tokens_1.colorNeutralForeground2,
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.4px",
            },
            children: isEmail ? "E-post-forhåndsvisning" : "Varsel-forhåndsvisning",
        }), createElement("span", {
            style: {
                marginLeft: "auto",
                fontSize: 11 + "px",
                color: tokens_1.colorNeutralForeground3,
            },
            children: `Til: ${recipientLabel}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
            padding: 14,
        }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 10 + "px ",
            alignItems: "flex-start",
        }], (elems_7 = toList(delay(() => {
            let elems_5, elems_4, el_6;
            return append(!isEmail ? singleton_1(createElement("div", createObj(ofArray([["style", {
                width: 28,
                height: 28,
                borderRadius: 14,
                backgroundColor: tokens_1.colorBrandBackground2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
                color: tokens_1.colorBrandForeground1,
                fontSize: 14 + "px",
                display: "flex",
                alignItems: "center",
            }], (elems_4 = [(el_6 = AlertRegular, createElement(el_6, {}))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty_1(), delay(() => {
                let elems_6;
                return singleton_1(createElement("div", createObj(ofArray([["style", {
                    flexGrow: 1,
                    minWidth: 0,
                }], (elems_6 = [createElement("div", {
                    style: {
                        fontSize: 13 + "px",
                        fontWeight: 600,
                        color: tokens_1.colorNeutralForeground1,
                        lineHeight: 1.4,
                        wordBreak: "break-word",
                    },
                    children: title,
                }), createElement("div", {
                    style: {
                        fontSize: 12 + "px",
                        color: tokens_1.colorNeutralForeground2,
                        marginTop: 4,
                        lineHeight: 1.5,
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                    },
                    children: message,
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), createElement("div", {
            style: {
                padding: ((6 + "px ") + 12) + "px",
                backgroundColor: tokens_1.colorNeutralBackground2,
                borderTop: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke3,
                fontSize: 11 + "px",
                color: tokens_1.colorNeutralForeground3,
            },
            children: "Eksempeldata · Anja Berg · Grunnleggende brannvern",
        })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
    }
}

function TriggerFields(triggerFieldsInputProps) {
    let elems_9;
    const courses = triggerFieldsInputProps.courses;
    const dispatch = triggerFieldsInputProps.dispatch;
    const model = triggerFieldsInputProps.model;
    const isWindowed = equals(model.TriggerType, new TriggerType(11, []));
    let isDaysInput;
    const matchValue = model.TriggerType;
    switch (matchValue.tag) {
        case 8:
        case 5:
        case 2:
        case 9:
        case 6:
        case 3:
        case 11: {
            isDaysInput = true;
            break;
        }
        default:
            isDaysInput = false;
    }
    let hasCourseFilters;
    const matchValue_1 = model.TriggerType;
    switch (matchValue_1.tag) {
        case 8:
        case 11: {
            hasCourseFilters = true;
            break;
        }
        default:
            hasCourseFilters = false;
    }
    const coursesMandatory = isWindowed;
    return createElement("div", createObj(singleton((elems_9 = toList(delay(() => {
        let el_3, matchValue_3, el;
        return append(isDaysInput ? singleton_1((el_3 = Field, createElement(el_3, {
            label: isWindowed ? "Frist (antall dager)" : "Antall dager",
            required: true,
            hint: isWindowed ? "Tiden brukeren har på å fullføre kursene. Eks. 270 ≈ 9 måneder." : "",
            children: (matchValue_3 = tryHead([(el = SpinButton, createElement(el, {
                value: model.Days,
                min: 1,
                max: 3650,
                onChange: (_arg, value_1_6) => {
                    const data = value_1_6;
                    iterate((arg) => {
                        dispatch(new Msg(8, [arg]));
                    }, toArray(orElseWith(data.value, () => {
                        if (isNullOrWhiteSpace(data.displayValue)) {
                            return undefined;
                        }
                        else {
                            let matchValue_2;
                            let outArg = 0;
                            matchValue_2 = [tryParse(data.displayValue, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                                outArg = (v | 0);
                            })), outArg];
                            if (matchValue_2[0]) {
                                return matchValue_2[1];
                            }
                            else {
                                return undefined;
                            }
                        }
                    })));
                },
            }))]), (matchValue_3 == null) ? defaultOf() : matchValue_3),
        }))) : empty_1(), delay(() => {
            let el_16, matchValue_6, el_13, elems_3, el_7, elems_1, el_5, el_11, elems_2, el_9;
            return hasCourseFilters ? append(!coursesMandatory ? singleton_1((el_16 = Field, createElement(el_16, {
                label: "Filter på kurs",
                hint: "Velg spesifikke kurs for aktivitetsmåling. Hvis ingen velges, brukes alle kurs på nivået.",
                children: (matchValue_6 = tryHead([(el_13 = Dropdown, createElement(el_13, createObj(ofArray([["value", (model.CourseFilterMode.tag === 0) ? "Alle kurs på nivået" : "Velg spesifikke kurs..."], ["onOptionSelect", (_arg_1, value_1_10) => {
                    const matchValue_5 = value_1_10.optionValue;
                    let matchResult, v_4, v_5;
                    if (matchValue_5 != null) {
                        if (matchValue_5 === toString(new CourseFilterMode(0, []))) {
                            matchResult = 0;
                            v_4 = matchValue_5;
                        }
                        else if (matchValue_5 === toString(new CourseFilterMode(1, []))) {
                            matchResult = 1;
                            v_5 = matchValue_5;
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                    switch (matchResult) {
                        case 0: {
                            dispatch(new Msg(9, [new CourseFilterMode(0, [])]));
                            dispatch(new Msg(10, [new Int32Array([])]));
                            break;
                        }
                        case 1: {
                            dispatch(new Msg(9, [new CourseFilterMode(1, [])]));
                            break;
                        }
                        case 2: {
                            break;
                        }
                    }
                }], (elems_3 = [(el_7 = Option, createElement(el_7, createObj(ofArray([["value", toString(new CourseFilterMode(0, []))], ["text", "Alle kurs på nivået"], (elems_1 = [(el_5 = Text$, createElement(el_5, {
                    children: "Alle kurs på nivået",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_11 = Option, createElement(el_11, createObj(ofArray([["value", toString(new CourseFilterMode(1, []))], ["text", "Velg spesifikke kurs..."], (elems_2 = [(el_9 = Text$, createElement(el_9, {
                    children: "Velg spesifikke kurs...",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (matchValue_6 == null) ? defaultOf() : matchValue_6),
            }))) : empty_1(), delay(() => {
                let el_25, matchValue_8, el_22, elems_6;
                return append((equals(coursesMandatory ? (new CourseFilterMode(1, [])) : model.CourseFilterMode, new CourseFilterMode(1, [])) && (courses.length > 0)) ? singleton_1((el_25 = Field, createElement(el_25, {
                    label: "Velg kurs",
                    required: coursesMandatory,
                    hint: coursesMandatory ? "Velg minst ett kurs som må fullføres innen fristen." : "",
                    children: (matchValue_8 = tryHead([(el_22 = Dropdown, createElement(el_22, createObj(ofArray([["multiselect", true], ["placeholder", "Velg kurs..."], ["value", (model.CourseFilterIds.length === 0) ? "Ingen valgt" : (`${model.CourseFilterIds.length} kurs valgt`)], ["selectedOptions", toArray_1(map(int32ToString, model.CourseFilterIds))], ["onOptionSelect", (_arg_2, value_1_22) => {
                        dispatch(new Msg(10, [choose((s) => {
                            let matchValue_7;
                            let outArg_1 = 0;
                            matchValue_7 = [tryParse(s, 511, false, 32, new FSharpRef(() => outArg_1, (v_6) => {
                                outArg_1 = (v_6 | 0);
                            })), outArg_1];
                            if (matchValue_7[0]) {
                                return matchValue_7[1];
                            }
                            else {
                                return undefined;
                            }
                        }, defaultArg(ofNullable(value_1_22.selectedOptions), []), Int32Array)]));
                    }], (elems_6 = toList(delay(() => map((tlc) => {
                        let elems_5, el_18;
                        const el_20 = Option;
                        return createElement(el_20, createObj(ofArray([["value", int32ToString(tlc.Id)], ["text", tlc.Course.Name], (elems_5 = [(el_18 = Text$, createElement(el_18, {
                            children: tlc.Course.Name,
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
                    }, courses))), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))]), (matchValue_8 == null) ? defaultOf() : matchValue_8),
                }))) : empty_1(), delay(() => {
                    let elems_8, el_27;
                    return singleton_1(createElement("div", createObj(ofArray([["style", {
                        marginTop: 16,
                        backgroundColor: tokens_1.colorNeutralBackground2,
                        borderRadius: 4,
                        padding: ((10 + "px ") + 12) + "px",
                        border: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke2,
                    }], (elems_8 = [(el_27 = Switch, createElement(el_27, {
                        checked: model.RequireAllCourses,
                        onChange: (delegateArg, delegateArg_1) => {
                            dispatch(new Msg(11, [delegateArg_1.checked]));
                        },
                        label: coursesMandatory ? "Krev alle valgte kurs fullført" : "Krev alle kurs fullført",
                    })), createElement("div", {
                        style: {
                            fontSize: 12 + "px",
                            color: tokens_1.colorNeutralForeground2,
                            marginTop: 4,
                            lineHeight: 1.4,
                        },
                        children: coursesMandatory ? (model.RequireAllCourses ? "Alle valgte kurs må være fullført innen fristen for å utløse handlingen." : "Minst ett av de valgte kursene må være fullført innen fristen.") : ((model.CourseFilterIds.length > 0) ? "Når aktivert må alle valgte kurs være fullført for å telle som aktivitet. Ellers teller ett fullført kurs." : "Når aktivert må alle kurs på nivået være fullført for å telle som aktivitet. Ellers teller ett fullført kurs."),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
                }));
            })) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))]))));
}

function NotificationFieldsBlock(notificationFieldsBlockInputProps) {
    let elems_8;
    const lastFocused = notificationFieldsBlockInputProps.lastFocused;
    const showAlsoEmailCheckbox = notificationFieldsBlockInputProps.showAlsoEmailCheckbox;
    const dispatch = notificationFieldsBlockInputProps.dispatch;
    const model = notificationFieldsBlockInputProps.model;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 12 + "px ",
    }], (elems_8 = toList(delay(() => {
        let el_3, matchValue, el;
        return append(singleton_1((el_3 = Field, createElement(el_3, {
            label: equals(model.ActionType, new ActionType(1, [])) ? "Emne" : "Tittel",
            required: true,
            children: (matchValue = tryHead([(el = Input, createElement(el, {
                value: model.Title,
                placeholder: "F.eks. {FIRST_NAME}, ditt læringsløp blir snart inaktivt",
                onChange: (_arg, value_1_5) => {
                    dispatch(new Msg(13, [value_1_5.value]));
                },
                onFocus: (_arg_1) => {
                    lastFocused.current = "title";
                },
            }))]), (matchValue == null) ? defaultOf() : matchValue),
        }))), delay(() => {
            let el_8, matchValue_1, el_5;
            return append(singleton_1((el_8 = Field, createElement(el_8, {
                label: "Melding",
                required: true,
                children: (matchValue_1 = tryHead([(el_5 = Textarea, createElement(el_5, {
                    resize: "vertical",
                    style: {
                        minHeight: 96,
                    },
                    value: model.Message,
                    placeholder: "Skriv en beskrivende melding...",
                    onChange: (_arg_2, value_1_10) => {
                        dispatch(new Msg(14, [value_1_10.value]));
                    },
                    onFocus: (_arg_3) => {
                        lastFocused.current = "message";
                    },
                }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
            }))), delay(() => append(singleton_1(createElement(TokenStrip, {
                triggerType: model.TriggerType,
                onInsert: (token) => {
                    if (lastFocused.current === "title") {
                        dispatch(new Msg(13, [model.Title + token]));
                    }
                    else {
                        dispatch(new Msg(14, [model.Message + token]));
                    }
                },
            })), delay(() => {
                let el_13, value_40, matchValue_2, el_10;
                return append(singleton_1((el_13 = Field, createElement(el_13, createObj(ofArray([["label", "Lenke (valgfritt)"], (value_40 = "Vises som {URL} i tittel og melding. Du kan bruke {TRACK_ID}, {LEVEL_ID} eller {USER_ID} i lenken (eks. /laeringslop/{TRACK_ID}).", ["hint", value_40]), ["children", (matchValue_2 = tryHead([(el_10 = Input, createElement(el_10, {
                    value: model.Url,
                    placeholder: "/laeringslop/{TRACK_ID}",
                    onChange: (_arg_4, value_1_15) => {
                        dispatch(new Msg(15, [value_1_15.value]));
                    },
                }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]]))))), delay(() => {
                    let el_30, matchValue_4, el_27, elems_6, el_17, elems_3, el_15, el_21, elems_4, el_19, el_25, elems_5, el_23;
                    return append(singleton_1((el_30 = Field, createElement(el_30, {
                        label: "Mottakere",
                        required: true,
                        children: (matchValue_4 = tryHead([(el_27 = Dropdown, createElement(el_27, createObj(ofArray([["value", RecipientType__ToDescription(model.Recipient)], ["onOptionSelect", (_arg_5, value_1_19) => {
                            const matchValue_3 = value_1_19.optionValue;
                            let matchResult, v_6, v_7, v_8;
                            if (matchValue_3 != null) {
                                if (matchValue_3 === toString(new RecipientType(0, []))) {
                                    matchResult = 0;
                                    v_6 = matchValue_3;
                                }
                                else if (matchValue_3 === toString(new RecipientType(1, []))) {
                                    matchResult = 1;
                                    v_7 = matchValue_3;
                                }
                                else if (matchValue_3 === toString(new RecipientType(2, []))) {
                                    matchResult = 2;
                                    v_8 = matchValue_3;
                                }
                                else {
                                    matchResult = 3;
                                }
                            }
                            else {
                                matchResult = 3;
                            }
                            switch (matchResult) {
                                case 0: {
                                    dispatch(new Msg(16, [new RecipientType(0, [])]));
                                    break;
                                }
                                case 1: {
                                    dispatch(new Msg(16, [new RecipientType(1, [])]));
                                    break;
                                }
                                case 2: {
                                    dispatch(new Msg(16, [new RecipientType(2, [])]));
                                    break;
                                }
                                case 3: {
                                    break;
                                }
                            }
                        }], (elems_6 = [(el_17 = Option, createElement(el_17, createObj(ofArray([["value", toString(new RecipientType(0, []))], ["text", RecipientType__ToDescription(new RecipientType(0, []))], (elems_3 = [(el_15 = Text$, createElement(el_15, {
                            children: RecipientType__ToDescription(new RecipientType(0, [])),
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (el_21 = Option, createElement(el_21, createObj(ofArray([["value", toString(new RecipientType(1, []))], ["text", RecipientType__ToDescription(new RecipientType(1, []))], (elems_4 = [(el_19 = Text$, createElement(el_19, {
                            children: RecipientType__ToDescription(new RecipientType(1, [])),
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_25 = Option, createElement(el_25, createObj(ofArray([["value", toString(new RecipientType(2, []))], ["text", RecipientType__ToDescription(new RecipientType(2, []))], (elems_5 = [(el_23 = Text$, createElement(el_23, {
                            children: RecipientType__ToDescription(new RecipientType(2, [])),
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))]), (matchValue_4 == null) ? defaultOf() : matchValue_4),
                    }))), delay(() => {
                        let el_32;
                        return showAlsoEmailCheckbox ? singleton_1((el_32 = Checkbox, createElement(el_32, {
                            label: "Send også e-post",
                            checked: model.AlsoEmail,
                            onChange: (_arg_6, c) => {
                                dispatch(new Msg(17, [Checkbox_toBool(c)]));
                            },
                        }))) : empty_1();
                    }));
                }));
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

function ActionFields(actionFieldsInputProps) {
    let elems_4, elems_8;
    const dispatch = actionFieldsInputProps.dispatch;
    const model = actionFieldsInputProps.model;
    const lastFocused = reactApi.useRef("message");
    const matchValue = model.ActionType;
    switch (matchValue.tag) {
        case 2:
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 12 + "px ",
            }], (elems_4 = toList(delay(() => {
                let el_7, matchValue_3, el_4, elems_1, el_2, elems, el;
                return append(singleton_1((el_7 = Field, createElement(el_7, {
                    label: "Ny status",
                    required: true,
                    children: (matchValue_3 = tryHead([(el_4 = Dropdown, createElement(el_4, createObj(ofArray([["value", UserState__ToDescription(UserState_FromInt_Z524259A4(model.NewState))], ["onOptionSelect", (_arg, value_1_4) => {
                        const matchValue_1 = value_1_4.optionValue;
                        if (matchValue_1 == null) {
                        }
                        else {
                            let matchValue_2;
                            let outArg = 0;
                            matchValue_2 = [tryParse(matchValue_1, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
                                outArg = (v_1 | 0);
                            })), outArg];
                            if (matchValue_2[0]) {
                                dispatch(new Msg(19, [matchValue_2[1]]));
                            }
                        }
                    }], (elems_1 = [(el_2 = Option, createElement(el_2, createObj(ofArray([["value", int32ToString(UserState__ToInt(new UserState(2, [])))], ["text", UserState__ToDescription(new UserState(2, []))], (elems = [(el = Text$, createElement(el, {
                        children: UserState__ToDescription(new UserState(2, [])),
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_3 == null) ? defaultOf() : matchValue_3),
                }))), delay(() => {
                    let elems_3, el_9, value_40;
                    return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                        padding: ((10 + "px ") + 12) + "px",
                        border: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke2,
                        borderRadius: 4,
                    }], (elems_3 = [(el_9 = Switch, createElement(el_9, {
                        checked: model.UseCustomMessage,
                        onChange: (delegateArg, delegateArg_1) => {
                            dispatch(new Msg(18, [delegateArg_1.checked]));
                        },
                        label: "Send varsel ved statusendring",
                    })), createElement("div", createObj(ofArray([["style", {
                        fontSize: 12 + "px",
                        color: tokens_1.colorNeutralForeground2,
                        marginTop: 4,
                        lineHeight: 1.4,
                    }], (value_40 = "Send et varsel og en e-post til berørt bruker når statusen endres. Plassholdere som {TRACK_NAME} kan brukes hvis tilgjengelige.", ["children", value_40])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => (model.UseCustomMessage ? singleton_1(createElement(NotificationFieldsBlock, {
                        model: model,
                        dispatch: dispatch,
                        showAlsoEmailCheckbox: true,
                        lastFocused: lastFocused,
                    })) : empty_1())));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
        case 3:
        case 4:
        case 5: {
            let infoText;
            const matchValue_4 = model.ActionType;
            infoText = ((matchValue_4.tag === 4) ? "Brukeren får tilgang til materialet (på/av) og mottar automatisk et varsel og en e-post om dette." : ((matchValue_4.tag === 5) ? "Tilgangen til materialet trekkes tilbake og brukeren mottar automatisk et varsel og en e-post om dette." : "Læringsløpet settes som inaktivt for berørt bruker. Slå på \"Tilpass varselet\" for å sende et varsel ved deaktivering."));
            let toggleHint;
            const matchValue_5 = model.ActionType;
            switch (matchValue_5.tag) {
                case 4:
                case 5: {
                    toggleHint = "Skriv egen tittel og melding for dette varselet. Brukbart for løp- eller nivå-spesifikk tekst (f.eks. {TRACK_NAME}, {LEVEL_NAME}).";
                    break;
                }
                default:
                    toggleHint = "Send et varsel og en e-post til berørt bruker når læringsløpet deaktiveres. Plassholdere som {TRACK_NAME} kan brukes.";
            }
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 12 + "px ",
            }], (elems_8 = toList(delay(() => {
                let elems_6, elems_5, el_11;
                return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                    padding: 12,
                    backgroundColor: tokens_1.colorNeutralBackground2,
                    borderRadius: 4,
                    fontSize: 13 + "px",
                    color: tokens_1.colorNeutralForeground2,
                    lineHeight: 1.5,
                }], (elems_6 = [createElement("span", createObj(ofArray([["style", {
                    color: tokens_1.colorNeutralForeground3,
                    verticalAlign: "-2px",
                    marginRight: 6,
                    fontSize: 14 + "px",
                    display: "inline-block",
                }], (elems_5 = [(el_11 = InfoRegular, createElement(el_11, {}))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), infoText], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                    let elems_7, el_13;
                    return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                        padding: ((10 + "px ") + 12) + "px",
                        border: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke2,
                        borderRadius: 4,
                    }], (elems_7 = [(el_13 = Switch, createElement(el_13, {
                        checked: model.UseCustomMessage,
                        onChange: (delegateArg_2, delegateArg_1_1) => {
                            dispatch(new Msg(18, [delegateArg_1_1.checked]));
                        },
                        label: "Tilpass varselet",
                    })), createElement("div", {
                        style: {
                            fontSize: 12 + "px",
                            color: tokens_1.colorNeutralForeground2,
                            marginTop: 4,
                            lineHeight: 1.4,
                        },
                        children: toggleHint,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => (model.UseCustomMessage ? singleton_1(createElement(NotificationFieldsBlock, {
                        model: model,
                        dispatch: dispatch,
                        showAlsoEmailCheckbox: true,
                        lastFocused: lastFocused,
                    })) : empty_1())));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
        }
        default:
            return createElement(NotificationFieldsBlock, {
                model: model,
                dispatch: dispatch,
                showAlsoEmailCheckbox: equals(model.ActionType, new ActionType(0, [])),
                lastFocused: lastFocused,
            });
    }
}

class StepInfo extends Record {
    constructor(Step, Label, Icon) {
        super();
        this.Step = Step;
        this.Label = Label;
        this.Icon = Icon;
    }
}

function StepInfo_$reflection() {
    return record_type("Rules.RuleDialog.StepInfo", [], StepInfo, () => [["Step", Step_$reflection()], ["Label", string_type], ["Icon", class_type("Fable.React.ReactElement")]]);
}

const allSteps = [new StepInfo(new Step(0, []), "Grunnleggende", (() => {
    const el = EditRegular;
    return createElement(el, {
        fontSize: 16,
    });
})()), new StepInfo(new Step(1, []), "Utløser", (() => {
    const el_2 = ClockRegular;
    return createElement(el_2, {
        fontSize: 16,
    });
})()), new StepInfo(new Step(2, []), "Handling", (() => {
    const el_4 = FlashRegular;
    return createElement(el_4, {
        fontSize: 16,
    });
})())];

function stepIndex(step) {
    switch (step.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function RuleDialog(ruleDialogInputProps) {
    let elems_21, elemsToUse;
    const mode = ruleDialogInputProps.mode;
    let patternInput;
    if (mode.tag === 1) {
        const existing = mode.fields[0];
        patternInput = [scopeFromExistingRule(existing), initFromExistingRule(existing), true];
    }
    else {
        const s = mode.fields[0];
        patternInput = [s, init(s), false];
    }
    const scope = patternInput[0];
    const isEditMode = patternInput[2];
    const patternInput_1 = reactApi.useReducer(update, patternInput[1]);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const patternInput_2 = reactApi.useState(isEditMode);
    const setIsOpen = patternInput_2[1];
    const isOpen = patternInput_2[0];
    const triggers = triggersForScope(scope);
    const actions = actionsForScope(scope);
    const courses = (scope.tag === 2) ? scope.fields[1] : [];
    const patternInput_3 = (mode.tag === 0) ? [0, 0] : ((mode.fields[0].tag === 1) ? [mode.fields[0].fields[0].Id, mode.fields[0].fields[0].Priority] : ((mode.fields[0].tag === 2) ? [mode.fields[0].fields[0].Id, mode.fields[0].fields[0].Priority] : [mode.fields[0].fields[0].Id, mode.fields[0].fields[0].Priority]));
    const ruleId = patternInput_3[0] | 0;
    const priority = patternInput_3[1] | 0;
    const isStepValid = (step) => {
        switch (step.tag) {
            case 1:
                if (TriggerType__IsTimeBased(model_1.TriggerType) ? (model_1.Days > 0) : true) {
                    if (model_1.TriggerType.tag === 11) {
                        return model_1.CourseFilterIds.length > 0;
                    }
                    else {
                        return true;
                    }
                }
                else {
                    return false;
                }
            case 2: {
                const hasTitleAndMessage = () => {
                    if (!isNullOrWhiteSpace(model_1.Title)) {
                        return !isNullOrWhiteSpace(model_1.Message);
                    }
                    else {
                        return false;
                    }
                };
                const matchValue_1 = model_1.ActionType;
                let matchResult;
                switch (matchValue_1.tag) {
                    case 4: {
                        if (model_1.UseCustomMessage) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    case 5: {
                        if (model_1.UseCustomMessage) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    case 3: {
                        if (model_1.UseCustomMessage) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    case 2: {
                        if (model_1.UseCustomMessage) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    default:
                        matchResult = 0;
                }
                switch (matchResult) {
                    case 0:
                        return hasTitleAndMessage();
                    case 1:
                        return hasTitleAndMessage();
                    default:
                        return true;
                }
            }
            default:
                return !isNullOrWhiteSpace(model_1.Name);
        }
    };
    const canNext = isStepValid(model_1.Step);
    const canSubmit = allSteps.every((s_1) => isStepValid(s_1.Step));
    const dependencies = [isOpen];
    reactApi.useEffect(() => {
        let matchResult_1, s_3;
        if (mode.tag === 0) {
            if (!isOpen) {
                matchResult_1 = 0;
                s_3 = mode.fields[0];
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                dispatch(new Msg(22, [s_3]));
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies);
    const handleClose = () => {
        if (mode.tag === 1) {
            mode.fields[2]();
        }
        else {
            setIsOpen(false);
        }
    };
    const dialogTitle = isEditMode ? "Rediger automatisering" : "Legg til automatisering";
    const submitButtonText = isEditMode ? "Lagre" : "Legg til";
    const el_52 = Dialog;
    return createElement(el_52, createObj(ofArray([["open", isOpen], ["onOpenChange", (_arg, value_1_1) => {
        const d = value_1_1;
        if (mode.tag === 1) {
            if (!d.open) {
                handleClose();
            }
        }
        else {
            setIsOpen(d.open);
        }
    }], (elems_21 = toList(delay(() => {
        let matchValue_4, el;
        return append((matchValue_4 = mode, (matchValue_4.tag === 1) ? (empty_1()) : singleton_1((el = DialogTrigger, createElement(el, {
            children: matchValue_4.fields[1],
        })))), delay(() => {
            let el_50, elems_20, elems_4, elems, el_4, el_2, elems_3, elems_18, elems_19;
            return singleton_1((el_50 = DialogSurface, createElement(el_50, createObj(ofArray([["style", {
                maxWidth: 620,
                maxHeight: 92 + "vh",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }], (elems_20 = [createElement("div", createObj(ofArray([["style", {
                padding: ((((((18 + "px ") + 22) + "px ") + 14) + "px ") + 22) + "px",
                borderBottom: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke3,
            }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 10 + "px ",
            }], (elems = [createElement("div", {
                style: {
                    fontSize: 18 + "px",
                    fontWeight: 600,
                    letterSpacing: "-0.2px",
                },
                children: dialogTitle,
            }), createElement("div", {
                style: {
                    flexGrow: 1,
                },
            }), createElement("span", {
                style: {
                    fontSize: 12 + "px",
                    color: tokens_1.colorNeutralForeground3,
                    fontVariantNumeric: "tabular-nums",
                },
                children: `Steg ${stepIndex(model_1.Step) + 1} av ${allSteps.length}`,
            }), (el_4 = Button, createElement(el_4, {
                appearance: "subtle",
                icon: (el_2 = DismissRegular, createElement(el_2, {
                    fontSize: 20,
                })),
                onClick: (_arg_1) => {
                    handleClose();
                },
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 4 + "px ",
                marginTop: 14,
            }], (elems_3 = toList(delay(() => collect((i) => {
                let elems_2, elems_1;
                const s_4 = item(i, allSteps);
                const currentIdx = stepIndex(model_1.Step) | 0;
                let canGoToStep;
                if (i < currentIdx) {
                    canGoToStep = true;
                }
                else {
                    const array_2 = take(i, allSteps);
                    canGoToStep = array_2.every((st) => isStepValid(st.Step));
                }
                return append(singleton_1(createElement("button", createObj(ofArray([["onClick", (_arg_2) => {
                    if (canGoToStep) {
                        dispatch(new Msg(0, [s_4.Step]));
                    }
                }], ["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 8 + "px ",
                    padding: ((6 + "px ") + 10) + "px",
                    borderRadius: 4,
                    border: (((0 + "px ") + "none") + " ") + "",
                    backgroundColor: (i === currentIdx) ? tokens_1.colorBrandBackground2 : "transparent",
                    cursor: "pointer",
                    fontFamily: "inherit",
                }], (elems_2 = [createElement("span", createObj(ofArray([["style", {
                    width: 20,
                    height: 20,
                    borderRadius: 10,
                    backgroundColor: (i < currentIdx) ? tokens_1.colorPaletteGreenBackground3 : ((i === currentIdx) ? tokens_1.colorBrandBackground : tokens_1.colorNeutralBackground3),
                    color: (i <= currentIdx) ? "#fff" : tokens_1.colorNeutralForeground2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 11 + "px",
                    fontWeight: 600,
                }], (elems_1 = toList(delay(() => {
                    let el_6;
                    return (i < currentIdx) ? singleton_1((el_6 = CheckmarkRegular, createElement(el_6, {
                        fontSize: 16,
                    }))) : singleton_1(int32ToString(i + 1));
                })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("span", {
                    style: {
                        fontSize: 13 + "px",
                        fontWeight: (i === currentIdx) ? 600 : 500,
                        color: (i === currentIdx) ? tokens_1.colorBrandForeground1 : tokens_1.colorNeutralForeground2,
                    },
                    children: s_4.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => ((i < (allSteps.length - 1)) ? singleton_1(createElement("div", {
                    style: {
                        flexGrow: 1,
                        height: 1,
                        backgroundColor: (i < currentIdx) ? tokens_1.colorBrandBackground : tokens_1.colorNeutralStroke2,
                        minWidth: 20,
                    },
                })) : empty_1())));
            }, rangeDouble(0, 1, allSteps.length - 1)))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
                padding: ((20 + "px ") + 22) + "px",
                overflowY: "auto",
                flexGrow: 1,
                minHeight: 360,
            }], (elems_18 = toList(delay(() => {
                let elems_8, el_11, matchValue_5, el_8, el_16, matchValue_6, el_13, elems_7;
                return append(equals(model_1.Step, new Step(0, [])) ? singleton_1(createElement("div", createObj(singleton((elems_8 = [createElement("div", {
                    style: {
                        fontSize: 15 + "px",
                        fontWeight: 600,
                        marginBottom: 3,
                    },
                    children: isEditMode ? "Rediger info" : "Gi automatiseringen et navn",
                }), createElement("div", {
                    style: {
                        fontSize: 13 + "px",
                        color: tokens_1.colorNeutralForeground2,
                        marginBottom: 18,
                    },
                    children: isEditMode ? "Oppdater navn og beskrivelse." : "Dette gjør det enklere å gjenfinne og administrere den senere.",
                }), (el_11 = Field, createElement(el_11, {
                    label: "Navn",
                    required: true,
                    children: (matchValue_5 = tryHead([(el_8 = Input, createElement(el_8, {
                        value: model_1.Name,
                        placeholder: "F.eks. Inaktivitetsvarsel 3 md",
                        onChange: (_arg_3, value_1_8) => {
                            dispatch(new Msg(3, [value_1_8.value]));
                        },
                    }))]), (matchValue_5 == null) ? defaultOf() : matchValue_5),
                })), (el_16 = Field, createElement(el_16, {
                    label: "Beskrivelse (valgfritt)",
                    children: (matchValue_6 = tryHead([(el_13 = Textarea, createElement(el_13, {
                        value: model_1.Description,
                        resize: "vertical",
                        style: {
                            minHeight: 80,
                        },
                        placeholder: isEditMode ? "Kort notat om hensikten" : "Kort notat om hensikten — hvem gjelder den, hvorfor ble den laget?",
                        onChange: (_arg_4, value_1_12) => {
                            dispatch(new Msg(4, [value_1_12.value]));
                        },
                    }))]), (matchValue_6 == null) ? defaultOf() : matchValue_6),
                })), createElement("div", createObj(ofArray([["style", {
                    marginTop: 12,
                    display: "flex",
                    flexDirection: "column",
                    gap: 6 + "px ",
                }], (elems_7 = toList(delay(() => {
                    let el_18;
                    return append(singleton_1((el_18 = Checkbox, createElement(el_18, {
                        label: "Vis nedtelling til bruker",
                        checked: model_1.ShowAutomationCountdown,
                        onChange: (_arg_5, c_1) => {
                            dispatch(new Msg(6, [Checkbox_toBool(c_1)]));
                        },
                    }))), delay(() => {
                        let el_20;
                        return isEditMode ? singleton_1((el_20 = Checkbox, createElement(el_20, {
                            label: "Aktiver automatiseringen",
                            checked: model_1.Enabled,
                            onChange: (_arg_6, c_2) => {
                                dispatch(new Msg(5, [Checkbox_toBool(c_2)]));
                            },
                        }))) : empty_1();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))]))))) : empty_1(), delay(() => {
                    let elems_12, elems_11;
                    return append(equals(model_1.Step, new Step(1, [])) ? singleton_1(createElement("div", createObj(singleton((elems_12 = [createElement("div", {
                        style: {
                            fontSize: 15 + "px",
                            fontWeight: 600,
                            marginBottom: 3,
                        },
                        children: "Når skal automatiseringen kjøre?",
                    }), createElement("div", {
                        style: {
                            fontSize: 13 + "px",
                            color: tokens_1.colorNeutralForeground2,
                            marginBottom: 18,
                        },
                        children: "Velg utløseren som starter handlingen.",
                    }), createElement("div", createObj(ofArray([["style", {
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 8 + "px ",
                        marginBottom: 16,
                    }], (elems_11 = toList(delay(() => map((triggerType) => {
                        let elems_10, el_26, elems_9, el_22, el_24;
                        const isSelected = equals(model_1.TriggerType, triggerType);
                        const el_28 = Card;
                        return createElement(el_28, createObj(ofArray([["onClick", (_arg_7) => {
                            dispatch(new Msg(7, [triggerType]));
                        }], ["appearance", "filled-alternative"], ["selected", isSelected], ["size", "small"], (elems_10 = [(el_26 = CardHeader, createElement(el_26, {
                            image: createElement("div", createObj(ofArray([["style", {
                                width: 32,
                                height: 32,
                                borderRadius: 16,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: isSelected ? tokens_1.colorBrandBackground : tokens_1.colorNeutralBackground3,
                                color: isSelected ? "#fff" : tokens_1.colorNeutralForeground2,
                            }], (elems_9 = [triggerIconForType(triggerType)], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))),
                            header: (el_22 = Body1Strong, createElement(el_22, {
                                children: TriggerType__ToDescription(triggerType),
                            })),
                            description: (el_24 = Caption1, createElement(el_24, {
                                children: TriggerType__ToHint(triggerType),
                            })),
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])])));
                    }, triggers))), ["children", reactApi.Children.toArray(Array.from(elems_11))])]))), createElement(TriggerFields, {
                        model: model_1,
                        dispatch: dispatch,
                        courses: courses,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_12))]))))) : empty_1(), delay(() => {
                        let elems_17, elems_15, elems_16;
                        return equals(model_1.Step, new Step(2, [])) ? singleton_1(createElement("div", createObj(singleton((elems_17 = [createElement("div", {
                            style: {
                                fontSize: 15 + "px",
                                fontWeight: 600,
                                marginBottom: 3,
                            },
                            children: "Hva skal skje?",
                        }), createElement("div", {
                            style: {
                                fontSize: 13 + "px",
                                color: tokens_1.colorNeutralForeground2,
                                marginBottom: 18,
                            },
                            children: "Velg én handling som utløses når betingelsen oppfylles.",
                        }), createElement("div", createObj(ofArray([["style", {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 8 + "px ",
                            marginBottom: 16,
                        }], (elems_15 = toList(delay(() => map((actionType) => {
                            let elems_14, el_34, elems_13, el_30, el_32;
                            const isSelected_1 = equals(model_1.ActionType, actionType);
                            const el_36 = Card;
                            return createElement(el_36, createObj(ofArray([["onClick", (_arg_8) => {
                                dispatch(new Msg(12, [actionType]));
                            }], ["appearance", "filled-alternative"], ["selected", isSelected_1], ["size", "small"], (elems_14 = [(el_34 = CardHeader, createElement(el_34, {
                                image: createElement("div", createObj(ofArray([["style", {
                                    width: 32,
                                    height: 32,
                                    borderRadius: 16,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: isSelected_1 ? tokens_1.colorBrandBackground : tokens_1.colorNeutralBackground3,
                                    color: isSelected_1 ? "#fff" : tokens_1.colorNeutralForeground2,
                                }], (elems_13 = [actionIconForType(actionType)], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))),
                                header: (el_30 = Body1Strong, createElement(el_30, {
                                    children: ActionType__ToDescription(actionType),
                                })),
                                description: (el_32 = Caption1, createElement(el_32, {
                                    children: ActionType__ToHint(actionType),
                                })),
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_14))])])));
                        }, actions))), ["children", reactApi.Children.toArray(Array.from(elems_15))])]))), createElement(ActionFields, {
                            model: model_1,
                            dispatch: dispatch,
                        }), createElement("div", createObj(ofArray([["style", {
                            marginTop: 18,
                        }], (elems_16 = [createElement("div", {
                            style: {
                                fontSize: 11 + "px",
                                fontWeight: 600,
                                color: tokens_1.colorNeutralForeground2,
                                letterSpacing: "0.3px",
                                textTransform: "uppercase",
                                marginBottom: 8,
                            },
                            children: "Forhåndsvisning",
                        }), createElement(NotificationPreview, model_1)], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))]))))) : empty_1();
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_18))])]))), createElement("div", createObj(ofArray([["style", {
                padding: ((14 + "px ") + 22) + "px",
                borderTop: (((1 + "px ") + "solid") + " ") + tokens_1.colorNeutralStroke3,
                display: "flex",
                gap: 8 + "px ",
                alignItems: "center",
            }], (elems_19 = toList(delay(() => {
                let el_38;
                return append(singleton_1((el_38 = Button, createElement(el_38, {
                    appearance: "subtle",
                    children: "Avbryt",
                    onClick: (_arg_9) => {
                        handleClose();
                    },
                }))), delay(() => append(singleton_1(createElement("div", {
                    style: {
                        flexGrow: 1,
                    },
                })), delay(() => {
                    let el_42, el_40;
                    return append(!equals(model_1.Step, new Step(0, [])) ? singleton_1((el_42 = Button, createElement(el_42, {
                        appearance: "secondary",
                        icon: (el_40 = ChevronLeftRegular, createElement(el_40, {
                            fontSize: 16,
                        })),
                        children: "Tilbake",
                        onClick: (_arg_10) => {
                            dispatch(new Msg(2, []));
                        },
                    }))) : empty_1(), delay(() => {
                        let el_46, el_44;
                        return append(!equals(model_1.Step, new Step(2, [])) ? singleton_1((el_46 = Button, createElement(el_46, {
                            appearance: "primary",
                            icon: (el_44 = ChevronRightRegular, createElement(el_44, {
                                fontSize: 16,
                            })),
                            iconPosition: "after",
                            children: "Neste",
                            disabled: !canNext,
                            onClick: (_arg_11) => {
                                if (canNext) {
                                    dispatch(new Msg(1, []));
                                }
                            },
                        }))) : empty_1(), delay(() => {
                            let el_48;
                            return equals(model_1.Step, new Step(2, [])) ? singleton_1((el_48 = Button, createElement(el_48, {
                                appearance: "primary",
                                disabled: !canSubmit ? true : model_1.IsSaving,
                                children: submitButtonText,
                                onClick: (_arg_12) => {
                                    dispatch(new Msg(21, [true]));
                                    const triggerConfig = createTriggerConfig(model_1.TriggerType, model_1.Days);
                                    const actionConfig = createActionConfig(model_1.ActionType, model_1.Title, model_1.Message, model_1.Url, model_1.Recipient, model_1.AlsoEmail, model_1.UseCustomMessage, model_1.NewState, model_1.DemoteBy);
                                    if (mode.tag === 1) {
                                        const existingRule = mode.fields[0];
                                        mode.fields[1]((existingRule.tag === 1) ? (new RuleUpdate(1, [new UpdateTrackRule(ruleId, existingRule.fields[0].TrackId, model_1.Name.trim(), isNullOrWhiteSpace(model_1.Description) ? undefined : model_1.Description, model_1.Enabled, priority, model_1.ShowAutomationCountdown, model_1.TriggerType, triggerConfig, model_1.ActionType, actionConfig)])) : ((existingRule.tag === 2) ? (new RuleUpdate(2, [new UpdateTrackLevelRule(ruleId, existingRule.fields[0].TrackLevelId, model_1.Name.trim(), isNullOrWhiteSpace(model_1.Description) ? undefined : model_1.Description, model_1.Enabled, priority, model_1.ShowAutomationCountdown, model_1.TriggerType, triggerConfig, model_1.ActionType, actionConfig, (model_1.CourseFilterMode.tag === 0) ? (new Int32Array([])) : model_1.CourseFilterIds, model_1.RequireAllCourses)])) : (new RuleUpdate(0, [new UpdateGlobalRule(ruleId, model_1.Name.trim(), isNullOrWhiteSpace(model_1.Description) ? undefined : model_1.Description, model_1.Enabled, priority, model_1.ShowAutomationCountdown, model_1.TriggerType, triggerConfig, model_1.ActionType, actionConfig)]))));
                                        dispatch(new Msg(21, [false]));
                                    }
                                    else {
                                        mode.fields[2]((scope.tag === 1) ? (new NewRule(1, [new NewTrackRule(scope.fields[0], model_1.Name.trim(), isNullOrWhiteSpace(model_1.Description) ? undefined : model_1.Description, model_1.Enabled, 0, model_1.ShowAutomationCountdown, model_1.TriggerType, triggerConfig, model_1.ActionType, actionConfig)])) : ((scope.tag === 2) ? (new NewRule(2, [new NewTrackLevelRule(scope.fields[0], model_1.Name.trim(), isNullOrWhiteSpace(model_1.Description) ? undefined : model_1.Description, model_1.Enabled, 0, model_1.ShowAutomationCountdown, model_1.TriggerType, triggerConfig, model_1.ActionType, actionConfig, (model_1.CourseFilterMode.tag === 0) ? (new Int32Array([])) : model_1.CourseFilterIds, model_1.RequireAllCourses)])) : (new NewRule(0, [new NewGlobalRule(model_1.Name.trim(), isNullOrWhiteSpace(model_1.Description) ? undefined : model_1.Description, model_1.Enabled, 0, model_1.ShowAutomationCountdown, model_1.TriggerType, triggerConfig, model_1.ActionType, actionConfig)]))));
                                        setIsOpen(false);
                                        dispatch(new Msg(21, [false]));
                                    }
                                },
                            }))) : empty_1();
                        }));
                    }));
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_19))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_20))])])))));
        }));
    })), (elemsToUse = ((length(elems_21) <= 2) ? elems_21 : take_1(2, elems_21)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

/**
 * Legacy wrapper for AddRuleDialog - use RuleDialog with AddMode instead
 */
export function AddRuleDialog(addRuleDialogInputProps) {
    const onSave = addRuleDialogInputProps.onSave;
    const trigger = addRuleDialogInputProps.trigger;
    const scope = addRuleDialogInputProps.scope;
    return createElement(RuleDialog, {
        mode: new DialogMode(0, [scope, trigger, onSave]),
    });
}

/**
 * Legacy wrapper for EditRuleDialog - use RuleDialog with EditMode instead
 */
export function EditRuleDialog(editRuleDialogInputProps) {
    const onClose = editRuleDialogInputProps.onClose;
    const onSave = editRuleDialogInputProps.onSave;
    const existingRule = editRuleDialogInputProps.existingRule;
    return createElement(RuleDialog, {
        mode: new DialogMode(1, [existingRule, onSave, onClose]),
    });
}

//# sourceMappingURL=RuleDialog.jsx.map
